document.querySelectorAll('[data-v-service]').forEach(function (root) {
  var select = root.querySelector('[data-v-variant]');
  var price = root.querySelector('[data-v-price]');
  var add = root.querySelector('[data-v-add]');
  var source = root.querySelector('[data-v-variants]');
  if (!select || !source || !price || !add) return;
  var variants;
  try { variants = JSON.parse(source.textContent); } catch (error) { return; }
  select.addEventListener('change', function () {
    var variant = variants.find(function (v) { return String(v.id) === select.value; });
    if (!variant) return;
    price.replaceChildren(document.createTextNode(variant.price + ' '));
    var currency = document.createElement('span'); currency.textContent = root.dataset.vCurrency || 'USD'; price.appendChild(currency);
    add.disabled = !variant.available;
    add.textContent = variant.available ? 'Add to project' : 'Currently unavailable';
    var url = new URL(window.location.href); url.searchParams.set('variant', variant.id); history.replaceState(null, '', url.toString());
  });
});
